import React, { useEffect, useState }                          from 'react';
import "./notifications.scss";
import Loader                                                  from '../../../reuseableComponents/Loader/Loader';
import Notification                                            from '../../../reuseableComponents/Notification';
import { getNotificationSettings, updateNotificationSettings } from "./apis/apis";
import { Form, Switch, Button }                                from 'antd';

let data = [
  {
    label: "Saved homes",
    value: "savedHomes",
    type: "switch",
    valuePropName: "checked"
  },
  {
    label: "Recommended homes",
    value: "recommendedHomes",
    type: "switch",
    valuePropName: "checked"
  },
  {
    label: "App updates",
    value: "appUpdates",
    type: "switch",
    valuePropName: "checked"
  },
  {
    label: "Nearby homes and open houses",
    value: "nearByHome",
    type: "switch",
    valuePropName: "checked"
  },
  {
    label: "Rental messages",
    value: "messages",
    type: "switch",
    valuePropName: "checked"
  },
  {
    label: "Price drops",
    value: "priceDrop",
    type: "switch",
    valuePropName: "checked"
  },
  {
    label: "Saved searches",
    value: "savedSearch",
    type: "switch",
    valuePropName: "checked"
  }
]
const Notifications = () => {
  const [state, setState] = useState({
    formData: data,
    isLoader: false,
    initValues: {}
  })
  const [form] = Form.useForm();
  const save = async (values) => {
    try {
      const response = await updateNotificationSettings(values)
      if (response?.data?.data) {
        Notification('success', "Notification settings has been changed.");
      }
      else {
        Notification('error', "Error");
      }
    }
    catch (e) {
      Notification('error', "Error");
    }
  };

    const fetchNotificationSettings = async () => {
        setState((prevState) => ({ ...prevState, isLoader: true }));

        try {
            const response = await getNotificationSettings();
            const fetchedData = response?.data?.data || {};

            const initialValuesData = data.reduce((acc, field) => {
                acc[field.value] = fetchedData.hasOwnProperty(field.value) ? fetchedData[field.value] : null;
                return acc;
            }, {});

            setState((prevState) => ({
                ...prevState,
                initValues: initialValuesData,
                isLoader: false,
            }));
        } catch (error) {
            console.error("Error fetching notification settings:", error);
            setState((prevState) => ({ ...prevState, isLoader: false }));
        }
    };



    useEffect(() => {
    fetchNotificationSettings()
  }, []);

  return state.isLoader ? <Loader/> :
    <div className={ "main-settings-container" }>
      <Form className={ "notificationsContainer" } form={ form } layout="horizontal" initialValues={ state.initValues }
            onFinish={ save }
      >
        { state.formData.map((item) => (
          <Form.Item key={ item.value } label={ <p style={ {
            width: "60%"
          } }>{ item.label }</p> } name={ item.value } valuePropName={ item.valuePropName }>
            <Switch/>
          </Form.Item>
        )) }

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
}

export default Notifications